import axios from 'axios'
import { ALTERAR_SENHA_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarUsuario (novaSenha, senhaAtual) {
  const url = `${URL}/usuarios/alterar-senha`;
  return dispatch => axios.post(url,{ novaSenha, senhaAtual } , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_SENHA_USUARIO,
        payload: response
      })
  );
}
